import { css } from 'styled-components';

export const fixedSurfaceInk = css`
  --ln-content: 255 255 255;
  --heading-text-color: rgb(255 255 255);
`;
